<script setup>
import { onMounted } from "vue";
import Chart from "chart.js/auto";

const props = defineProps({
  id: {
    type: String,
    default: "default-doughnut-chart",
  },
  height: {
    type: String,
    default: "200",
  },
  title: {
    type: String,
    default: "Default Doughnut Chart",
  },
  chart: {
    type: Object,
    required: true,
    labels: String,
    datasets: {
      type: Array,
      label: String,
      data: Array,
    },
  },
  actions: {
    type: Object,
    route: String,
    color: String,
    label: String,
    default: () => ({
      color: "secondary",
      label: "See all refferals",
    }),
  },
});

onMounted(() => {
  let chart = document.getElementById(props.id).getContext("2d");

  let chartStatus = Chart.getChart(props.id);
  if (chartStatus != undefined) {
    chartStatus.destroy();
  }

  new Chart(chart, {
    type: "doughnut",
    data: {
      labels: props.chart.labels,
      datasets: [
        {
          label: props.chart.datasets[0].label,
          weight: 9,
          cutout: 60,
          tension: 0.9,
          pointRadius: 2,
          borderWidth: 2,
          backgroundColor: [
            "#2152ff",
            "#3A416F",
            "#f53939",
            "#a8b8d8",
            "#4BB543 ",
            "#4BX143 ",

          ],
          data: props.chart.datasets[0].data,
          fill: false,
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
        },
      },
      interaction: {
        intersect: false,
        mode: "index",
      },
      scales: {
        y: {
          grid: {
            drawBorder: false,
            display: false,
            drawOnChartArea: false,
            drawTicks: false,
          },
          ticks: {
            display: false,
          },
        },
        x: {
          grid: {
            drawBorder: false,
            display: false,
            drawOnChartArea: false,
            drawTicks: false,
          },
          ticks: {
            display: false,
          },
        },
      },
    },
  });
});
</script>
<template>
  <div class="card h-100">
    <div class="p-3 pb-0 card-header">
      <div class="d-flex align-items-center">
        <h6 class="mb-0">{{ props.title }}</h6>
        <button
          type="button"
          class="mb-0 btn btn-icon-only btn-rounded btn-outline-secondary ms-2 btn-sm d-flex align-items-center justify-content-center ms-auto"
          data-bs-toggle="tooltip"
          data-bs-placement="bottom"
          title="See which websites are sending traffic to your website"
        >
          <i class="fas fa-info"></i>
        </button>
      </div>
    </div>
    <div class="p-3 card-body">
      <div class="row">
        <div class="text-center col-lg-5 col-12">
          <div class="mt-5 chart">
            <canvas
              :id="props.id"
              class="chart-canvas"
              :height="props.height"
            ></canvas>
          </div>
          <a
            class="mt-4 btn btn-sm"
            :href="props.actions.route"
            :class="`bg-gradient-${props.actions.color}`"
          >
            {{ props.actions.label }}
          </a>
        </div>
        <div class="col-lg-7 col-12">
          <div class="table-responsive">
            <table class="table mb-0 align-items-center">
              <tbody>
                <tr v-for="(label, index) in props.chart.labels" :key="index">
                  <td>
                    <div class="px-2 py-1 d-flex">
                      <div>
                        <!-- Replace image with an icon -->
                        <i class="fas fa-cogs avatar avatar-sm me-2"></i>
                      </div>
                      <div class="d-flex flex-column justify-content-center">
                        <h6 class="mb-0 text-sm">{{ label }}</h6>
                      </div>
                    </div>
                  </td>
                  <td class="text-sm text-center align-middle">
                    <span class="text-xs font-weight-bold">
                      {{ props.chart.datasets[0].data[index] }}%
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
